import { createContext, useEffect, useState } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';

export interface TripPageData {
  diveOperatorName: string
  locationName: string
  tripId: string
}

export interface TripDataContextValue {
  tripPageData: TripPageData;
}

interface TripDataProviderProps {
  tripPageData: TripPageData
  children?: ReactNode;
}

export const TripDataContext = createContext<TripDataContextValue>({
  tripPageData: {
    tripId: "tripId",
    diveOperatorName: "default name",
    locationName: "locationName"
  },
});

export const TripDataProvider: FC<TripDataProviderProps> = (props) => {
  const { children, tripPageData } = props;



  // useEffect(() => {
  //   const restoredSettings = restoreSettings();
  //
  //   if (restoredSettings) {
  //     setSettings(restoredSettings);
  //   }
  // }, []);
  //
  // const saveSettings = (updatedSettings: Settings): void => {
  //   setSettings(updatedSettings);
  //   storeSettings(updatedSettings);
  // };

  return (
    <TripDataContext.Provider
      value={{
        tripPageData
      }}
    >
      {children}
    </TripDataContext.Provider>
  );
};

TripDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
  tripPageData: PropTypes.shape({
    tripId: PropTypes.string.isRequired,
    diveOperatorName: PropTypes.string.isRequired,
    locationName: PropTypes.string.isRequired
  }).isRequired

};

export const TripDataConsumer = TripDataContext.Consumer;
